'use client'

import dynamic from 'next/dynamic'

const VideoFrame = dynamic(() => import('./lb-video-frame').then(m => m.VideoFrame), { ssr: false })

export function DynamicVideoFrame({ videoUrl }: { videoUrl: string }) {
  return <VideoFrame videoUrl={videoUrl} />
}
